import { useAppNotifications } from "@/hooks/useAppNotifications";
import { Stack } from "@mui/material";
import { useWidth } from "@/hooks/useWidth";
import { useAuth } from "react-oidc-context";

import { TOAST_AUTO_HIDE_DURATION } from "@/constants";
import { useClipboardCopy } from "@/hooks/useClipboardCopy";
import { useTranslation } from "react-i18next";
import { Button, Typography } from "@trimble/modus-cmx";

const DebugWindow = () => {
  const width = useWidth();

  const { user } = useAuth();
  const notifications = useAppNotifications();
  const { copy } = useClipboardCopy();
  const { t } = useTranslation();

  const handleClick = () => {
    if (user?.access_token) {
      copy(user.access_token, t("debug.copy_jwt_success"));
    } else {
      notifications.show(t("debug.no_jwt_available"), {
        severity: "error",
        autoHideDuration: TOAST_AUTO_HIDE_DURATION,
      });
    }
  };

  return (
    <Stack
      sx={{
        position: "fixed",
        bgcolor: "var(--modus-wc-color-gray-10)",
        p: 1,
        zIndex: 1000,
        top: 0,
        color: "var(--modus-wc-color-white)",
      }}
    >
      <Typography size="sm">{t("debug.debug_window")}</Typography>
      <Typography size="sm">{t("debug.width", { width })}</Typography>
      <Button onButtonClick={handleClick} size="sm">
        {t("debug.copy_jwt")}
      </Button>
    </Stack>
  );
};

export default DebugWindow;
